import {CacheState} from "./CacheState";
import {CommentFull} from "../../model/comment/CommentFull";

export class ReportCommentFullListState implements CacheState {
    constructor(public reportId: number | undefined = undefined,
                public commentFulls: CommentFull[] = [],
                public pendingRequest: boolean = false,
                public loaded: boolean = false) {}
}